// removed by extract-text-webpack-plugin
module.exports = {"font-header":"buttons-module__font-header__1jX4S","fontHeader":"buttons-module__font-header__1jX4S","font-primary":"buttons-module__font-primary__1zXzR","fontPrimary":"buttons-module__font-primary__1zXzR","font-secondary":"buttons-module__font-secondary__2SN9i","fontSecondary":"buttons-module__font-secondary__2SN9i","sr-only":"buttons-module__sr-only__1GwXN","srOnly":"buttons-module__sr-only__1GwXN","sr-only-important":"buttons-module__sr-only-important__2TCU7","srOnlyImportant":"buttons-module__sr-only-important__2TCU7","buttonClean":"buttons-module__buttonClean__3E0OI"};


//////////////////
// WEBPACK FOOTER
// ./src/global_styles/buttons.module.scss
// module id = 819
// module chunks = 0